import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_SERVICE_TYPE,
  DELETE_SERVICE_TYPE,
  GET_SERVICE_TYPES,
  UPDATE_SERVICE_TYPE,
  UPDATE_SERVICE_TYPE_STATUS
} from "./actionTypes";

import {
  addServiceTypeFail,
  addServiceTypeSuccess,
  deleteServiceTypeFail,
  deleteServiceTypeSuccess,
  getServiceTypesFail,
  getServiceTypesSuccess,
  setState,
  updateServiceTypeFail,
  updateServiceTypeSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { serviceTypes, updateStatus } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchServiceTypes({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, serviceTypes, params.toString());
    yield put(setState(false));
    yield put(getServiceTypesSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getServiceTypesFail(error));
  }
}

function* updateServiceType({ payload: serviceTypeObj }) {
  try {
    const { id, ...rest } = serviceTypeObj;
    yield call(patchApiCall, `${serviceTypes}/${id}`, rest);
    const response = yield call(getTable, `${serviceTypes}/${serviceTypeObj.id}`);
    yield put(updateServiceTypeSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    yield put(updateServiceTypeFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateServiceTypeStatus({ payload: serviceTypeObj }) {
  try {
    yield call(patchApiCall, `${serviceTypes}/${updateStatus}/${serviceTypeObj.id}`, { recordStatus: serviceTypeObj.recordStatus });
    const response = yield call(getTable, `${serviceTypes}/${serviceTypeObj.id}`);
    yield put(updateServiceTypeSuccess(response));
  } catch (error) {
    yield put(updateServiceTypeFail(error));
  }
}

function* deleteServiceType({ payload: serviceTypeObj }) {
  try {
    yield call(deleteApiCall, `${serviceTypes}/${serviceTypeObj.id}`);
    yield put(deleteServiceTypeSuccess(serviceTypeObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteServiceTypeFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingServiceType({ payload: serviceType }) {
  try {
    const response = yield call(postApiCall, serviceTypes, serviceType);
    yield put(addServiceTypeSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addServiceTypeFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* serviceTypesSaga() {
  yield takeEvery(GET_SERVICE_TYPES, fetchServiceTypes);
  yield takeEvery(ADD_NEW_SERVICE_TYPE, postingServiceType);
  yield takeEvery(UPDATE_SERVICE_TYPE, updateServiceType);
  yield takeEvery(UPDATE_SERVICE_TYPE_STATUS, updateServiceTypeStatus);
  yield takeEvery(DELETE_SERVICE_TYPE, deleteServiceType);
}

export default serviceTypesSaga;
